import { createAsyncThunk } from "@reduxjs/toolkit";
// import { enqueueSnackbar } from "notistack";

import { IGetLookupsRequest } from "../../services/apiV2.types";
import { getLookups } from "../../services/apiV2";
// import { INTERNAL_SERVER_ERROR } from "../../constants";

export const getLookupsThunk = createAsyncThunk(
  "lookups/getLookupsThunk",
  async (req: IGetLookupsRequest, { rejectWithValue }) => {
    try {
      const res = await getLookups(req);
      return res.data;
    } catch (e) {
      console.error(e);
      // enqueueSnackbar(INTERNAL_SERVER_ERROR, { variant: "error" });
      return rejectWithValue(e);
    }
  },
);
